export default function getAvailableJobCustomers(): string {
  return `/exporting/lists/customers`;
}
